module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-25547682.webp";